import Tooltips from "../../../scomponents/tooltips/Tooltips";



// UTILS

function getTooltipContent(opener) {
    return opener.getAttribute('aria-label');
}

function getAriaControls(opener) {
    const attrValue = opener.getAttribute('aria-controls');

    if (attrValue) {
        return attrValue.split(' ').map(item => item.trim());
    }

    return [];
}

function isCanHold(opener) {
    return getAriaControls(opener).includes('tooltip-click-to-hold');
}

function shouldSetWidthFitContent(opener) {
    return getAriaControls(opener).includes('tooltip-should-set-width-fit-text');
}

function isHtmlContentTrusted(opener) {
    return getAriaControls(opener).includes('tooltip-is-html-content-trusted');
}


/**
 *
 * @param {HTMLElement|Node} el
 * @param {number?} triedCount
 * @return {*}
 */
function findOpener(el, triedCount = 0) {
    if (!(el instanceof HTMLElement)) {
        return null;
    }

    if (getTooltipContent(el)) {
        return el;
    }

    if (triedCount < 3) {
        return findOpener(el.parentNode, triedCount + 1);
    }

    return null;
}




// MAIN

let activeOpener = null;
let holdingOpener = null;

function onMouseMove(ev) {
    const opener = findOpener(ev.target);

    if (opener !== null && opener === activeOpener) {
        return;
    }

    if (opener !== null && opener === holdingOpener) {
        return;
    }

    if (activeOpener !== null) {
        deactivate();
    }

    if (opener === null) {
        return;
    }

    activate(opener);
}

function activate(opener) {
    activeOpener = opener;

    Tooltips.add(getTooltipContent(opener), opener, {
        appearance: 'soft',
        noCloseButton: true,
        noPointer: true,
        delayedBeforeAppend: true,
        isHtmlContentTrusted: isHtmlContentTrusted(opener),
        shouldSetWidthFitContent: shouldSetWidthFitContent(opener)
    });

    if (isCanHold(opener)) {
        listenForHold(opener);
    }
}

function deactivate() {
    Tooltips.remove(activeOpener);

    activeOpener = null;
}

function hold(opener) {
    holdingOpener = opener;

    holdingOpener.classList.add('tooltip-is-holding');

    Tooltips.add(getTooltipContent(opener), opener, {
        appearance: 'hard',
        isHtmlContentTrusted: isHtmlContentTrusted(opener),
        shouldSetWidthFitContent: shouldSetWidthFitContent(opener)
    }, (opener) => {
        opener.classList.remove('tooltip-is-holding');

        if (opener === holdingOpener) {
            holdingOpener = null;
        }
    });
}

function listenForHold(opener) {
    opener.addEventListener('click', ev => {
        ev.stopPropagation();

        deactivate();

        hold(opener);
    });
}



// EXPORT

export default function () {
    document.addEventListener('mousemove', onMouseMove, {capture: true, passive: true});
}
